/**
 * @fileoverview PATCH handler for the "/comments/:target/threads/:thread_id/comments/:comment_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { mutationCacheKeys } from "./constants";
import type { AppendAppGroupToUrl, EditCommentProps, EmptyResult as EditCommentResult } from "./types";

export const editComment = reactQueryMutationAdapter(
  mutationCacheKeys,
  (props: AppendAppGroupToUrl<EditCommentProps>): Promise<EditCommentResult> => {
    return fetch(
      `/comments/${props.target}/threads/${props.threadId}/comments/${props.commentId}?app_group_id=${props.appGroupId}`,
      "PATCH",
      {
        message: props.message,
      }
    );
  }
);
